export const ctaList = [
  'welcome.payfit.com',
  '/demo/',
  '/fr/demo/',
  '/es/demo/',
];
